import { PipeTransform } from '@angular/core';
var NumberFormatPipe = /** @class */ (function () {
    function NumberFormatPipe() {
    }
    NumberFormatPipe.prototype.transform = function (value) {
        if (isNaN(value)) {
            return value.toString();
        }
        return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(value);
    };
    return NumberFormatPipe;
}());
export { NumberFormatPipe };
